const constants = {
  WEDDING_TABS_PAGE: "/wedding-song-easy-tabs"
};
export default constants;
